import { Icon } from '@ridi/rsg';
import { Fragment, createElement } from 'react';

var Empty = function (props) {
    var title = props.title, description = props.description, linkText = props.linkText, linkUrl = props.linkUrl, onLinkClick = props.onLinkClick, iconName = props.iconName, className = props.className;
    var shouldDisplayLink = !!linkText && !!linkUrl;
    return (createElement("div", { className: "rui_empty_1 " + className },
        createElement(Icon, { className: "empty_mark", name: iconName }),
        title && createElement("h3", { className: "empty_title" }, title),
        description && (createElement("p", { className: "empty_description" },
            description,
            shouldDisplayLink && (createElement(Fragment, null,
                createElement("br", null),
                createElement("a", { onClick: onLinkClick, href: linkUrl },
                    linkText,
                    " ",
                    createElement(Icon, { className: "right_arrow_icon", name: "arrow_9_right" }))))))));
};

export { Empty };
//# sourceMappingURL=Empty.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/Empty.js